<template>
  <div class="home">
    <div class="platform">
        <div class="platform-cen clearfloat">
            <h1>一站式企业数字化运营协作平台</h1>
            <p>为制造企业提供全方位的数字化服务，帮助企业更高效的运行与发展</p>
            <div class="platform-btn">
                <button @click="openPopUp()">立即咨询</button>
                <button @click="openUrl('/product')">了解详情</button>
            </div>
            <div class="cover">
                <img src="../assets/home/cover.png" alt="">
            </div>
        </div>
    </div>

    <div class="analysis">
        <div class="analysis-cen">
            <h1>专业全面覆盖 倾力满足行业所需</h1>
            <p>专为阀门制造行业定制的ERP系统，全面的业务管理功能直击行业痛点</p>
            <div class="analysis-imgs">
                <img src="../assets/home/analysis1.png" alt="">
                <img src="../assets/home/analysis2.png" alt="">
                <img src="../assets/home/analysis3.png" alt="">
                <img src="../assets/home/analysis4.png" alt="">
            </div>
            <button @click="openUrl('/product')">了解详情</button>
        </div>
    </div>

    <div class="advantage">
        <div class="advantage-cen">
            <h1>数字化助力企业智能管理的优点</h1>
            <p>随着全球化竞争越来越激烈，中小型企业亟待企业转型以应对市场的变化</p>
            <div class="advantage-main">
                <div>提高资金运营效率</div>
                <div>提高市场的竞争力</div>
                <div>降低成本改善质量</div>
                <div>提高客户的满意度</div>
            </div>
        </div>
    </div>


    <div class="giveService">
        <div class="giveService-cen">
            <div class="solution">
                <p>灵活的解决方案</p>

                <div class="giveService-scroll">
                    <p :class="{ 'giveService-active': currentIndex === 0 }" @click="showContent(0)">定制化高适应性</p>
                    <p :class="{ 'giveService-active': currentIndex === 1 }" @click="showContent(1)">模块化高拓展性</p>
                    <p :class="{ 'giveService-active': currentIndex === 2 }" @click="showContent(2)">高性价比灵活报价</p>
                </div>

                <button @click="openPopUp()">立即咨询</button>
            </div>
            <div class="solution-content">
                <div  v-if="currentIndex === 0">
                    <p>
                        理业管理系统具有高度的模块化和可扩展性，可以根据您企业的实际情况进行模块化开发和扩展，满
                        足您企业的不同需求。无论是增加新的业务功能还是扩展新的业务模块，理业管理系统都能够帮助您实现
                        快速开发和升级。
                    </p>
                    <p>
                        我们提供了多种标准模块，同时也可以根据客户需求定制各种模块，满足不同客户的需求，提供最优 的解决方案。
                    </p>
                </div>
                <div v-if="currentIndex === 1">
                    <p>
                        我们的产品采用模块化设计，具备极高的拓展性。客户可以根据业务的不断发展和变化，灵活添加或更换模块，实现系统的无缝升级和功能扩展。模块化的结构不仅简化了维护和管理，也确保了系统的持久生命力和持续创新能力。
                    </p>
                </div>
                <div v-if="currentIndex === 2">
                    <p>
                        我们致力于为客户提供高性价比的解决方案。通过灵活的报价策略，我们能够在保证产品和服务质量的前提下，最大程度地降低客户的成本。无论是一次性购买还是长期合作，我们都提供透明、合理的报价，确保客户获得最大的价值回报。
                    </p>
                </div>
            </div>
        </div>
    </div>

    <div class="hand">
        <div class="hand-cen">
            <h1>成功案例 与企业共擎数字化新增长</h1>
            <a @click="openPopUp()" style="cursor: pointer;">了解更多</a>

            <div class="hand-imgs">
                <div>
                    <img src="../assets/home/fbvtp.png" alt="">
                    <p>
                        <img src="../assets/home/fbvLogo.png" alt="">
                        <br>
                        <span>理业管理系统为阀毕威阀门有限公司提供全线数字化服务，帮助企业实现从生产到销售的全线业务闭环，完成各平台数据集成切实助力企业实现增产降本。</span>
                    </p>
                </div>
                <div>
                    <img src="../assets/home/human2.png" alt="">
                    <p>
                        <img src="../assets/home/human1.png" alt="">
                        <br>
                        <span>丽水瑞城人力有限公司致力于为客户提供高效、专业的人力资源服务，帮助企业降低人力资源管理成本，提升企业竞争力。公司拥有一支经验丰富的专业团队，能够根据客户的具体需求，提供个性化的解决方案。</span>
                    </p>
                </div>
                <div>
                    <img src="../assets/home/machinery1.png" alt="">
                    <p>
                        <img src="../assets/home/machinery2.png" alt="">
                        <br>
                        <span style="margin-top: 0px;">凡天智能以技术为核心，以客户需求为导向，不断创新和提升，为全球客户提供领先的智能机械臂解决方案，推动工业自动化的发展。</span>
                    </p>
                </div>
            </div>
        </div>
    </div>

    <pop-up :display="showPopUp" @update:display="updateDisplay"></pop-up>


  </div>
</template>

<script>
import popUp from '@/components/popUp.vue'

export default {
    components:{popUp},
    name: 'home',
    data () {
        return {
            currentIndex: 0,
            showPopUp: false,
            intervalId: null
        }
    },
    methods: {
        showContent(index) {
            this.currentIndex = index;
        },
        startCarousel() {
            this.intervalId = setInterval(() => {
                this.currentIndex = (this.currentIndex + 1) % 3; // Assuming there are 3 items
            }, 5000); // Change every 3 seconds
        },
        stopCarousel() {
            if (this.intervalId) {
                clearInterval(this.intervalId);
                this.intervalId = null;
            }
        },
        openUrl(url) {
            let urls = this.$router.resolve({
                path: url,
            });
            window.open(urls.href, "_self");
        },
        openPopUp() {
            this.showPopUp = true
        },
        updateDisplay(newValue) {
            this.showPopUp = newValue;
        }
    },
    mounted() {
        this.startCarousel();
    },
    beforeDestroy() {
        this.stopCarousel();
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.platform {
    background: url(../assets/home/banner1.png);
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    position: relative;
    height: 522px;
}
.platform-cen,.analysis-cen,.advantage-cen,.giveService-cen,.hand-cen {
    width: 1460px;
    margin: 0 auto;
}
.platform-cen h1{
    font-weight: 500;
    font-size: 44px;
    color: #132053;
    font-style: normal;
    margin-top: 90px;
    margin-bottom: 12px;
}
.platform-cen p{
    font-weight: 400;
    font-size: 18px;
    color: #132053;
    font-style: normal;
    margin-bottom: 54px
}
.platform-btn button {
    width: 160px;
    height: 52px;
    color: white;
    border: none;
    border-radius: 4px;
    font-size: 16px;
    cursor: pointer;
    transition: background-color 0.3s;
}
.platform-btn button:nth-child(1) {
    background: #2B77FF;
    margin-right: 16px;
}
.platform-btn button:nth-child(2) {
    color: #2B77FF;
    border: 1px solid #2B77FF;
    box-sizing: border-box;
    background: #eef4fc;
}
.platform-btn button:nth-child(1):hover {
    background-color: #1a5bcc; /* 添加按钮悬停效果 */
}
.platform-btn button:nth-child(2):hover {
    background-color: #377ee7; /* 添加按钮悬停效果 */
    color: #fff;
}
.cover {
    position: absolute;
    bottom: -13%;
}
.cover img {
    margin: 0 auto 0 -14px
}

.analysis {
    background: url(../assets/home/numberback.png);
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    position: relative;
}
.analysis-cen {
    text-align: center;
    padding-top: 128px;
    box-sizing: border-box;
}
.analysis-cen h1 {
    font-weight: 500;
    font-size: 36px;
    color: #132053;
    font-style: normal;
    margin-bottom: 4px;
}
.analysis-cen p {
    font-weight: 400;
    font-size: 14px;
    color: #132053;
    font-style: normal;
    margin-bottom: 42px;
}
.analysis-cen button {
    width: 200px;
    height: 40px;
    color: white;
    border: none;
    border-radius: 4px;
    font-size: 16px;
    cursor: pointer;
    background: #2B77FF;
    transition: background-color 0.3s;
    margin: 46px 0;
}
.analysis-cen button:hover {
    background-color: #1a5bcc; /* 添加按钮悬停效果 */
}
.analysis-imgs {
    display: flex;
    justify-content: space-between;
}
.analysis-imgs img {
    transition: all 0.3s;
    cursor: pointer;
}
.analysis-imgs img:hover {
    z-index: 2;
    box-shadow: 0 15px 30px rgba(77, 67, 67, 0.2);
    transform: translate3d(0, -2px, 0);
}

.advantage {
    background: url(../assets/home/benner2.png);
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    height: 664px;
}
.advantage-cen {
    text-align: center;
    padding-top: 70px;
    box-sizing: border-box;
}
.advantage-cen h1 {
    font-weight: 500;
    font-size: 36px;
    color: #132053;
    font-style: normal;
    margin-bottom: 4px;
}
.advantage-cen p {
    font-weight: 400;
    font-size: 14px;
    color: #132053;
    font-style: normal;
    margin-bottom: 98px;
}
.advantage-main {
    width: 792px;
    height: 272px;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    align-content: space-between;
    justify-content: space-between;
    float: right;
}
.advantage-main div {
    width: 380px;
    height: 120px;
    background: linear-gradient( 180deg, #F1F5FD 0%, #FBFCFF 100%);
    box-shadow: 2px 2px 4px 0px #ECECEC;
    border-radius: 4px;
    border: 2px solid #FFFFFF;
    font-weight: 500;
    font-size: 26px;
    color: #1E6BFF;
    line-height: 120px;
    text-align: center;
    font-weight: 500;
    transition: all 0.3s;
    cursor: pointer;
}
.advantage-main div:hover {
    z-index: 2;
    box-shadow: 0 15px 10px rgba(77, 67, 67, 0.1);
}

.giveService {
    background: url(../assets/home/carousel.png);
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    height: 498px;
}
.giveService-cen {
    padding-top: 108px;
    box-sizing: border-box;
    position: relative;
}
.solution {

}
.solution > p {
    font-weight: 500;
    font-size: 26px;
    color: #FFFFFF;
    font-style: normal;
    margin-bottom: 18px;
}
.solution button {
    width: 144px;
    height: 44px;
    border-radius: 4px;
    border: 1px solid #FFFFFF;
    background-color:rgba(0,0,0,0);
    font-weight: 500;
    font-size: 18px;
    color: #FFFFFF;
    margin-top: 26px;
    transition: all .3s;
    cursor: pointer;
}
.solution button:hover {
    background-color: #0a61f8; /* 添加按钮悬停效果 */
}
.giveService-scroll {
    border-left: 1px solid #FFFFFF;
    font-weight: 400;
    font-size: 18px;
    color: #FFFFFF;
    width: 452px;
}
.giveService-scroll p{
    height: 50px;
    font-weight: 400;
    font-size: 18px;
    color: #FFFFFF;
    font-style: normal;
    line-height: 50px;
    padding-left: 30px;
    cursor: pointer;
    transition: all .2s;
}
.giveService-scroll p:hover{   
    background-color:rgba(255, 255, 255, 0.2);
}
.giveService-active {
    background-color:rgba(255, 255, 255, 0.2);
}
.solution-content {
    
}
.solution-content div {
    width: 966px;
    height: 268px;
    background: linear-gradient(#E3EDFF 0%, #FFFFFF 100%);
    box-shadow: 4px 6px 8px 4px rgba(76,136,233,0.14);
    border-radius: 4px;
    padding-top: 38px;
    padding-left: 58px;
    padding-right: 58px;
    position: absolute;
    right: -135px;
    top: 112px
}
.solution-content div p {
    font-weight: 400;
    font-size: 18px;
    color: #676767;
    line-height: 45px;
    text-indent: 2em;
}
.solution-content div p:not(:first-child) {
    margin-top: 10px;
}

.hand {
    background: #EDF4FF;
    height: 698px;
}
.hand-cen {
    padding-top: 70px;
    text-align: center;
}
.hand-cen h1 {
    font-weight: 500;
    font-size: 36px;
    color: #3F3F3F;
    margin-bottom: 4px;
}
.hand-cen a {
    font-weight: 400;
    font-size: 14px;
    color: #2A77FE;
    text-decoration-line: underline;
}
.hand-imgs {
    display: flex;
    justify-content: space-between;
    margin-top: 75px;
}
.hand-imgs div {
    width: 453px;
    box-shadow: 0px 1px 10px 5px #e4e4e4;
    text-align: left;
    border-radius: 13px;
}
.hand-imgs div > img{
    width: 453px;
    height: 188px;
}
.hand-imgs div p {
    height: 210px;
    padding: 18px 0 0 8px;
    box-sizing: border-box;
    background: #fff;
    border-radius: 0 0 13px 13px;
}
.hand-imgs div p img{
    /* width: 236px; */
    /* height: 58px; */
}
.hand-imgs div p span {
    display: inline-block;
    margin-top: 24px;
    padding: 0 30px;
    font-weight: 400;
    font-size: 14px;
    color: #3F3F3F;
    line-height: 28px;
}

@media (max-width: 1750px) {
    .solution-content div {
        width: 700px;
        position: absolute;
        right: -65px;
        top: 112px
    }
}
@media (max-width: 1600px) {
    .solution-content div {
        width: 650px;
        position: absolute;
        right: 6px;
        top: 112px
    }
}

</style>



// WEBPACK FOOTER //
// src/components/home.vue